'use client';

import { RefObject, useState } from 'react';
import { Container } from 'react-bootstrap';

import { ChildrenProps } from '@/types/common.types';

import { useScrollToElement } from '@/hooks/useScrollToElement';
import { FilterMovieProvider } from '@/views/FilteredMoviesView/contexts/useFilterMovieContext';
import { usePreferFilterList } from '@/views/FilteredMoviesView/usePreferFilterList';

import styles from '@/views/FilteredMoviesView/FilteredMoviesView.module.scss';
import { FiltersModal } from '@/views/FilteredMoviesView/FiltersModal';
import { PersistableFiltersForm } from '@/views/FilteredMoviesView/PersistableFiltersForm';

// =================================================================

export const FilteredMoviesView = (props: ChildrenProps) => {
  const { children } = props;

  const { filterList, isLoading } = usePreferFilterList();

  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState<boolean>(false);
  const toggleFiltersModal = () => setIsFiltersModalOpen(state => !state);

  const { ref, scrollToElement } = useScrollToElement({ offset: 100 });

  const handleFiltersSubmitted = () => {
    scrollToElement();
    toggleFiltersModal();
  };

  return (
    <FilterMovieProvider
      countries={filterList?.countries || []}
      genres={filterList?.genres || []}
      qualities={filterList?.qualities || []}
      cinemas={filterList?.cinemas || []}
      onSubmitted={handleFiltersSubmitted}
      isLoading={isLoading}
    >
      <div className={styles.filtersTopPanel}>
        <Container>
          <PersistableFiltersForm />
        </Container>
      </div>
      <div ref={ref as RefObject<HTMLDivElement>}>{children}</div>
      <div className={styles.filteredWrapper}>
        <FiltersModal size="lg" isOpen={isFiltersModalOpen} onClose={toggleFiltersModal}>
          <PersistableFiltersForm containerClassName={styles.filtersContainer} />
        </FiltersModal>
        {/* <IconButton
          as="button"
          icon={FiltersSVG}
          iconWidth={22}
          iconHeight={22}
          onClick={toggleFiltersModal}
          className={styles.filtersButton}
        /> */}
      </div>
    </FilterMovieProvider>
  );
};
